import _ResultHandlerJson from './ResultHandlerJson'

export const ResultHandlerJson = _ResultHandlerJson
